/**
 * If enabled, retailer will be eligible to see the FD MP discount modal more than once.  * PRD: https:www.notion.so/faire/Targeted-Recurring-MP-Discount-Modal-f6d4859c8d0944d6b3b3ec1bbed38d28
 */
export const FAIRE_DIRECT_TARGETED_RECURRING_MARKETPLACE_MODAL_240826 = 'FAIRE_DIRECT_TARGETED_RECURRING_MARKETPLACE_MODAL_240826';
